import {
  Avatar,
  Box,
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as yup from "yup";
import productPay from "../assets/productPay.svg";
import CreateForm from "../components/forms/CreateForm";
import GButtonContained from "../components/GButtonContained";
import { fetchWrapper } from "../helper/api";
import couponForm from "../helper/forms/couponForm";
import mainForm from "../helper/forms/mainFormJSON";
import { DefaultValues, PaymentCountFormValues } from "../interfaces/forms";
import { ReturnObjType } from "../interfaces/products";
import { actions } from "../redux/actions";
import strings from "../utils/strings.json";
import ErrorPage from "./ErrorPage";
import priceForm from "../helper/forms/priceForm";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { theme } from "../utils/customColors";

const schemaValidations = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().required().email(),
  cellPhone: yup.string().required().max(10).min(10),
  identityId: yup.string().required().max(10),
});

const couponSchemaValidations = yup.object().shape({
  couponCode: yup.string(),
});
const priceSchemaValidations = yup.object().shape({
  price: yup.string(),
});

const countOption = [
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
  { label: '32', value: 32 },
  { label: '33', value: 33 },
  { label: '34', value: 34 },
  { label: '35', value: 35 },
  { label: '36', value: 36 }
]

function Layout(props: any) {
  const [pageError, setPageError] = useState(false);
  const [returnObj, setReturnObj] = useState<ReturnObjType>({});
  const [productId, setProductId] = useState("");
  const [managerId, setManagerId] = useState("");
  const [iframeLink, setIframeLink] = useState("");
  const [currPrice, setCurrPrice] = useState("");
  const [productUuid, setProductUuid] = useState("");
  const [showCouponForm, setShowCouponForm] = useState(false);
  const [notFoundCoupon, setNotFoundCoupon] = useState(false);
  const [loadingCoupon, setLoadingCoupon] = useState<boolean>(false);
  const [loadingPay, setLoadingPay] = useState<boolean>(false);
  const [dataForm, setDataForm] = useState<DefaultValues>();
  const [couponCodeNumber, setCouponCodeNumber] = useState(0);
  const [acceptedSuccessFully, setAcceptedSuccessFully] = useState("");
  const [successPayment, setSuccessPayment] = useState(false)
  const [errorPayment, setErrorPayment] = useState(false)
  const [paymentData, setPaymentData] = useState<PaymentCountFormValues>({})
  const [recurringUpdate, setRecurringUpdate] = useState(false)
  const [paymentTypeParam, setPaymentTypeParam] = useState(0)
  useEffect(() => {
    let managerIdLocal;
    let productIdLocal;
    let catalogIdLocal;
    let url = window.location.href;
    let uri = decodeURI(url);
    let array = uri.split(`?`)[1].split("&");
    let successPaymentTemp = false
    let paymentTypeParam: any = 0
    paymentTypeParam = array.find((item) => item.includes("payment-method"))?.split("=")[1]
    setPaymentTypeParam(paymentTypeParam)

    if (array[0].includes("terminalnumber")) {
      // check if payment success
      if (array.find((item) => item === "ResponeCode=0")) {
        successPaymentTemp = true
        setSuccessPayment(true)
      }
      else {
        successPaymentTemp = true
        setErrorPayment(true)
      }
    }
    else
      array.forEach(function (item) {
        let temp = item.split("=");
        switch (temp[0]) {
          case "manager-id":
            setManagerId(temp[1]);
            managerIdLocal = temp[1];
            break;
          case "product-id":
            productIdLocal = temp[1];
            setProductId(temp[1]);
            break;
          case "catalog-id":
            catalogIdLocal = temp[1];
            break;
          case "first-name":
            setDataForm((prev) => {
              return { ...prev, firstName: temp[1] };
            });
            break;
          case "last-name":
            setDataForm((prev) => {
              return { ...prev, lastName: temp[1] };
            });
            break;
          case "phone":
            setDataForm((prev) => {
              return { ...prev, cellPhone: temp[1] };
            });
            break;
          case "email":
            setDataForm((prev) => {
              return { ...prev, email: temp[1] };
            });
            break;
          case "id-number":
            setDataForm((prev) => {
              return { ...prev, idNumber: temp[1] };
            });
            break;
          case "gooly":
            setDataForm((prev) => {
              return { ...prev, gooly: temp[1] };
            });
            break;
          default:
            break;
        }
      });

    if (!successPaymentTemp)
      fetchWrapper
        .get(
          `handling-gateway/getProductByIdAndCatalog/${productIdLocal}/${catalogIdLocal}`
        )
        .then(({ data }) => {
          if (data && managerIdLocal) {
            props.setCurrProduct(data);
          } else {
            setPageError(true);
          }
          //   });
        })
        .catch(() => { });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (props.currProduct) {
      if (paymentTypeParam?.toString() === "1") {
        setPaymentData({ ...paymentData, price: props.currProduct?.price / Number(props.currProduct.paymentsCount?.toString() || '2'), paymentCount: props.currProduct.paymentsCount?.toString() || '2' });
      }
      else {
        setPaymentData({ paymentCount: props.currProduct.paymentsCount?.toString() || '2', price: props.currProduct?.price })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currProduct])

  const submitForm = (data) => {
    setReturnObj(data);
    if (data.cellPhone?.length === 10) {
      setShowCouponForm(true);
    }
  };
  const sendCouponToDb = async (data?) => {
    if (returnObj.cellPhone && returnObj.cellPhone.length === 10) {
      let item = await {
        cellPhone: returnObj.cellPhone,
        identityId: returnObj.identityId || null,
        firstName: returnObj.firstName || null,
        email: returnObj.email || null,
        lastName: returnObj.lastName || null,
        gooly: returnObj.gooly || true,
        createdBy: Number(managerId),
      };
      if (data.couponCode) {
        setLoadingCoupon(true);
        setCouponCodeNumber(data.couponCode)

        await fetchWrapper
          .post(
            `handling-gateway/findCouponByCodeCoupon/${productId}/${data.couponCode}`,
            item
          )
          .then(({ data }) => {
            setNotFoundCoupon(false);
            if (paymentTypeParam?.toString() === "1") {
              setCurrPrice((data.sumToPay).toString());
              setPaymentData({ ...paymentData, price: data.sumToPay / Number(paymentData.paymentCount) });
            }
            else {
              if (props.currProduct.paymentType === "RECURRING") {
                setCurrPrice((data.sumToPay * Number(paymentData.paymentCount)).toString());
              }
              else
                setCurrPrice(data.sumToPay);

              setPaymentData({ ...paymentData, price: data.sumToPay });
            }
            setProductUuid(data.uuid);
          })
          .catch(() => {
            setNotFoundCoupon(true);
          });
        setLoadingCoupon(false);
      } else {
        setLoadingCoupon(true);
        setNotFoundCoupon(false);
        await fetchWrapper
          .post(
            `handling-gateway/createProductUserWithoutCoupon/${productId}`,
            item
          )
          .then(({ data }) => {
            if (paymentTypeParam?.toString() === "1") {
              setCurrPrice((data.sumToPay).toString());
              setPaymentData({ ...paymentData, price: data.sumToPay / Number(paymentData.paymentCount) });
            }
            else {
              if (props.currProduct.paymentType === "RECURRING") {
                setCurrPrice((data.sumToPay * Number(paymentData.paymentCount)).toString());
              }
              else
                setCurrPrice(data.sumToPay);
              setPaymentData({ ...paymentData, price: data.sumToPay });
            }
            setProductUuid(data.uuid);
          })
          .catch(() => {
            // setPageError(true)
          });
        setLoadingCoupon(false);
      }
    }
  };

  async function sendPriceToDb(data) {
    let item = await {
      cellPhone: returnObj.cellPhone,
      identityId: returnObj.identityId || null,
      firstName: returnObj.firstName || null,
      email: returnObj.email || null,
      lastName: returnObj.lastName || null,
      price: data.price,
      createdBy: Number(managerId),
      paymentType: paymentTypeParam?.toString() === "1" ? "RECURRING" : null
    };

    setLoadingCoupon(true);
    setNotFoundCoupon(false);
    await fetchWrapper
      .post(
        `handling-gateway/createProductUserWithoutCoupon/${productId}`,
        item
      )
      .then(({ data }) => {
        if (paymentTypeParam?.toString() === "1") {
          setCurrPrice((data.sumToPay).toString());
          setPaymentData({ ...paymentData, price: data.sumToPay / Number(paymentData.paymentCount) });
        }
        else {

          if (props.currProduct.paymentType === "RECURRING") {
            setCurrPrice((data.sumToPay * Number(paymentData.paymentCount)).toString());
          }
          else
            setCurrPrice(data.sumToPay);

          setPaymentData({ ...paymentData, price: data.sumToPay });
        }
        setProductUuid(data.uuid);
      })
      .catch(() => {
        // setPageError(true)
      });
    setLoadingCoupon(false);
  }

  const getIframeLink = async () => {
    setLoadingPay(true);
    await fetchWrapper
      .get(`handling-gateway/getPayment/${productUuid}`)
      .then(({ data }) => {
        setIframeLink(data?.Url || data?.Data?.RedirectURL);
        // setIframeLink(data.Data.RedirectURL);
      })
      .catch(() => {
        // setPageError(true)
      });
    setLoadingPay(false);
  };

  const updateProductUser = async () => {
    setLoadingPay(true);
    if (returnObj.cellPhone && returnObj.cellPhone.length === 10) {
      let item = await {
        cellPhone: returnObj.cellPhone,
        identityId: returnObj.identityId || null,
        firstName: returnObj.firstName || null,
        email: returnObj.email || null,
        lastName: returnObj.lastName || null,
        gooly: returnObj.gooly || true,
        createdBy: Number(managerId),
      };
      if (couponCodeNumber) {
        await fetchWrapper
          .post(
            `handling-gateway/updateProductForZeroAmount/${productId}/${couponCodeNumber}`,
            item
          )
          .then(({ data }) => {
            if (data === "הצליח") {
              setLoadingPay(false);
              setLoadingCoupon(false);
              setAcceptedSuccessFully("התקבל בהצלחה")
            }
            else {
              setPageError(true)
            }
          })
          .catch(() => {
            setPageError(true)
          });
      };
    }

  }

  const updateRecurringPayment = async () => {
    let item = await {
      cellPhone: returnObj.cellPhone,
      identityId: returnObj.identityId || null,
      firstName: returnObj.firstName || null,
      email: returnObj.email || null,
      lastName: returnObj.lastName || null,
      gooly: returnObj.gooly || true,
      createdBy: Number(managerId),
      amountForMonth: paymentData.price,
      paymentCount: paymentData.paymentCount?.toString(),
      amountTotal: currPrice
    };
    await fetchWrapper
      .post(
        `handling-gateway/createProductUserWithoutCoupon/${productId}`,
        item
      )
      .then(({ data }) => {
        setRecurringUpdate(true)
      })
  }
  return (
    <>
      <Stack spacing={{ xs: 0, sm: 10 }} direction="row" flexWrap="wrap" p={5}>
        {!pageError && !successPayment && !errorPayment && (
          <Box pb={4} sx={{ flex: { xs: 12, sm: 2 } }}>
            <Box sx={{ minWidth: { xs: "100%", sm: 380 } }}>
              <Typography
                align="right"
                pb={2.5}
                sx={{
                  fontSize: 36,
                  fontWeight: 400,
                }}
              >
                :שם המוצר
              </Typography>
              <Box
                borderRadius={4}
                position="sticky"
                px={2}
                py={4}
                boxShadow="0px 48px 64px rgba(51, 51, 51, 0.15)"
              >
                <Box sx={{ direction: "rtl" }}>
                  <Avatar
                    src={productPay}
                    alt="Remy Sharp"
                    sx={{
                      height: 68,
                      width: 68,
                    }}
                  />
                </Box>
                <Typography
                  align="right"
                  pt={3}
                  sx={{
                    fontSize: 28,
                    fontWeight: 700,
                    // color: "black",
                  }}
                >
                  {props.currProduct?.name}
                </Typography>
                <Typography
                  align="right"
                  py={2}
                  pl={2}
                  sx={{
                    fontSize: 24,
                    fontWeight: 400,
                    direction: "rtl",
                  }}
                >
                  {props.currProduct?.description}{" "}
                </Typography>
                <Divider light />
                <Box display="flex" sx={{ direction: "rtl" }}>
                  {currPrice &&
                    Number(currPrice) !== Number(props.currProduct?.price) && (
                      <Typography
                        align="right"
                        py={3}
                        pl={2}
                        sx={{
                          fontSize: 26,
                          textDecorationLine: "line-through",
                        }}
                      >
                        ₪{props.currProduct?.price}
                      </Typography>
                    )}
                  <Stack>
                    <Typography
                      align="right"
                      py={3}
                      sx={{
                        fontSize: 26,
                        color: "#46B6E7",
                      }}
                    >
                      ₪{props.currProduct.paymentType === "RECURRING" ? Number(paymentData?.price)?.toFixed(2) : currPrice ? currPrice : props.currProduct?.price}
                    </Typography>
                    {props.currProduct?.flexible ? (
                      <Typography
                        sx={{
                          color: "#E74646",
                        }}
                      >
                        מחיר גמיש*
                      </Typography>
                    ) : <></>}
                  </Stack>
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        <Box
          // pl={4}
          sx={{
            display: "flex",
            direction: "rtl",
            flex: { sm: 7 },
          }}
        >
          {pageError ? (
            <Paper
              sx={{
                p: 2,
                maxWidth: 760,
                flexGrow: 1,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "#1A2027" : "#fff",
              }}
            >
              <Grid item xs={7}>
                <ErrorPage />
              </Grid>
            </Paper>
          ) : successPayment || errorPayment ?
            <Box sx={{ textAlign: "start", pb: 2, pr: 2, }}>
              <div style={{ fontSize: 24, color: theme.palette.primary.main, fontWeight: 600 }}>{successPayment ? strings.layout.success : strings.layout.errorPayment}</div>
            </Box> :
            iframeLink ?
              (
                <Box
                  sx={{
                    maxWidth: 760,
                    width: "80vw",
                    height: { xs: "120vh", sm: "80vh" },
                  }}
                >
                  <iframe
                    src={iframeLink}
                    style={{
                      border: 0,
                      width: "100%",
                    }}
                    height="100%"
                    title="payment-form"
                  />
                </Box>
              ) : (
                props.currProduct?.id && (
                  <Grid container direction="column">
                    <Box sx={{ direction: "rtl" }}>
                      <Typography
                        align="right"
                        pb={2.5}
                        sx={{
                          fontSize: 36,
                          fontWeight: 400,
                        }}
                      >
                        פרטים אישיים{" "}
                      </Typography>
                      <Grid container sx={{ direction: "rtl" }}>
                        <CreateForm
                          handleClose={props.handleClose}
                          handleAction={submitForm}
                          form={mainForm}
                          schema={schemaValidations}
                          isCoupon={false}
                          defaultValues={dataForm}
                        >
                          {!props.currProduct?.flexible ? (
                            <Typography
                              pr={3}
                              sx={{ pb: { xs: 2, sm: 0 } }}
                              variant="body1"
                              color="text.secondary"
                            >
                              * הוספת קוד קופון תתאפשר לאחר מילוי הפרטים
                            </Typography>
                          ) : (
                            <></>
                          )}
                        </CreateForm>
                      </Grid>
                    </Box>

                    {!props.currProduct?.flexible ? (
                      <>
                        <Divider sx={{ py: 2 }} light />
                        <Box sx={{ direction: "rtl" }}>
                          <Typography
                            align="right"
                            pt={5}
                            pb={2}
                            sx={{
                              fontSize: 36,
                              fontWeight: 400,
                            }}
                          >
                            קופון{" "}
                          </Typography>
                          {showCouponForm && (
                            <>
                              <CreateForm
                                handleClose={sendCouponToDb}
                                handleAction={sendCouponToDb}
                                form={couponForm}
                                schema={couponSchemaValidations}
                                isCoupon={true}
                                loadingCoupon={loadingCoupon}
                              >
                                <>
                                  {notFoundCoupon && (
                                    <Typography
                                      align="right"
                                      pr={3}
                                      sx={{
                                        fontWeight: 400,
                                        color: "red",
                                      }}
                                    >
                                      הקופון לא נמצא{" "}
                                    </Typography>
                                  )}
                                </>
                              </CreateForm>
                            </>
                          )}
                        </Box>
                      </>
                    ) : (
                      <Box sx={{ direction: "rtl" }}>
                        <Typography
                          align="right"
                          pt={5}
                          pb={2}
                          sx={{
                            fontSize: 36,
                            fontWeight: 400,
                          }}
                        >
                          מחיר
                        </Typography>
                        {showCouponForm && (
                          <>
                            <CreateForm
                              // handleClose={sendCouponToDb}
                              handleAction={sendPriceToDb}
                              form={priceForm}
                              schema={priceSchemaValidations}
                              isCoupon={false}
                              loadingCoupon={loadingCoupon}
                            ></CreateForm>
                          </>
                        )}
                      </Box>
                    )}
                    {(props.currProduct.paymentType === "RECURRING" || paymentTypeParam?.toString() === "1") &&
                      (
                        <>
                          <Divider sx={{ py: 2 }} light />
                          <Box sx={{ direction: "rtl" }}>
                            <Typography
                              align="right"
                              pt={5}
                              pb={2}
                              sx={{
                                fontSize: 36,
                                fontWeight: 400,
                              }}
                            >
                              מספר תשלומים{" "}
                            </Typography>
                            {(productUuid) &&
                              <CacheProvider value={createCache({
                                key: "muirtl",
                                stylisPlugins: [prefixer, rtlPlugin],
                              })}>
                                <Grid container rowSpacing={8} columnSpacing={5} justifyContent="end">
                                  <Grid item xs={12} md={6}>
                                    <TextField
                                      label="בחר מספר תשלומים"
                                      sx={{ width: "100%" }}
                                      value={paymentData.paymentCount}
                                      onChange={(e) => { setPaymentData({ paymentCount: e.target.value, price: ((Number(paymentData.price) * Number(paymentData.paymentCount)) / Number(e.target.value)) }) }}
                                      select
                                    >
                                      {countOption &&
                                        countOption.map((option: any) => (
                                          <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                          </MenuItem>
                                        ))}
                                    </TextField>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <TextField
                                      sx={{ width: "100%" }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      InputProps={{ inputProps: { min: 0 } }}
                                      label="סכום לתשלום חודשי"
                                      type="string"
                                      value={paymentData?.price?.toFixed(2).toString() || 0}
                                      onChange={(e) => {
                                        setPaymentData({ paymentCount: paymentData.paymentCount, price: parseInt(e.target.value) });
                                        setCurrPrice((parseInt(e.target.value) * Number(paymentData.paymentCount)).toString());
                                      }}

                                    />
                                  </Grid>
                                  <Stack
                                    justifyContent="end"
                                    pt={2}
                                    sx={{
                                      flexDirection: { xs: "column-reverse", sm: "row-reverse" },
                                      alignItems: "center",
                                    }}
                                  >
                                    <GButtonContained
                                      text={strings.button.next}
                                      handleAction={updateRecurringPayment}
                                    />
                                  </Stack>
                                </Grid>
                              </CacheProvider>
                            }
                          </Box>
                        </>
                      )}

                    <Divider sx={{ py: 2 }} light />
                    <Typography
                      align="right"
                      pt={5}
                      pb={2}
                      sx={{
                        fontSize: 36,
                        fontWeight: 400,
                      }}
                    >
                      תשלום{" "}
                    </Typography>
                    {!productUuid && <Divider sx={{ py: 2 }} light />}

                    {productUuid && (props.currProduct.paymentType !== "RECURRING" || recurringUpdate) && (
                      <>
                        <Typography variant="h6" gutterBottom>
                          {strings.layout.totalPrice}
                          {Number(currPrice).toLocaleString("en-us") +
                            " " +
                            (props.currProduct.currency === "ILS" ? "₪" : "$")}
                        </Typography>

                        <Box
                          display="flex"
                          sx={{ direction: "ltr", pt: 2, pb: 10 }}
                        >
                          {loadingPay ? (
                            <CircularProgress sx={{ ml: 13 }} color="info" />
                          ) : parseInt(currPrice) <= 0 ?
                            acceptedSuccessFully === "" ?
                              <GButtonContained
                                handleAction={updateProductUser}
                                text="סיום"
                              /> :
                              <Typography
                                align="right"
                                pt={5}
                                pb={2}
                                sx={{
                                  fontSize: 36,
                                  fontWeight: 400,
                                }}
                              >
                                {acceptedSuccessFully}
                              </Typography>

                            : (
                              <GButtonContained
                                handleAction={getIframeLink}
                                text="המשך לתשלום"
                              />
                            )}
                        </Box>
                      </>
                    )}
                  </Grid>
                )
              )}
        </Box>
      </Stack >
    </>
  );
}
export default connect(
  (state: any) => {
    return {
      currProduct: state.product.currProduct,
    };
  },
  (dispatch: any) => ({
    setCurrProduct: (val: any) => {
      dispatch(actions.setCurrProduct(val));
    },
  })
)(Layout);
